module.exports = __webpack_public_path__ + "img/solution_4.ea651a1f.png";